//import moment from 'moment'
//import {UNITS} from '../constants/gui_units'
import {StaticData} from './StaticData.js'

export default class FormProperty {

  constructor() {
    this.title = ""
    this.name = ""
    this.value = ""

    this.dataTypeID = -1
    this.lengthMin = 0
    this.lengthMax = 0
    this.paramInfoFormat = ""
    this.readonly = false
    this.paramInfoTooltip = ""
    this.autofocus = false
    this.ocrEnabled = false
    this.nullValueReplacement = false

    this.validate = null           // fun - validator implementation
    this.invalid = false           // true/FALSE - is the field correctly validated
    this.systemParameter = false   // true/FALSE - is it a magic parameter, which is skipped in rendering the formular (e.g. :userLoginName, :sessionID, ...)

    this.invalid = false
    this.component = null          // render vue component (one from components/forms)

    //console.log("FormProperty mapper class called...")
  }

  // Query Parameter mappings
  static createFromSQLDeclare(sqlDeclareBackendBean) {
    //console.warn("createFromSQLDeclare")
    sqlDeclareBackendBean.i1type = StaticData.PROPERTY_TYPES.PROP_TYPE_PARAMETER
    sqlDeclareBackendBean.classID = sqlDeclareBackendBean.ID
    sqlDeclareBackendBean.nativename = sqlDeclareBackendBean.name
    sqlDeclareBackendBean.commaPost = sqlDeclareBackendBean.paramCommaPost
    sqlDeclareBackendBean.commaPre = sqlDeclareBackendBean.paramCommaPre
    sqlDeclareBackendBean.valueList = sqlDeclareBackendBean.paramValuelist
    return sqlDeclareBackendBean
  }

  static createFromFormProperty(formPropertyBackendBean) {
    //console.warn("createFromFormProperty")
    formPropertyBackendBean.i1type = StaticData.PROPERTY_TYPES.PROP_TYPE_FORMULAR
    formPropertyBackendBean.valueList = formPropertyBackendBean.valuelistDomain
    //formPropertyBackendBean.valueListType = formPropertyBackendBean.valuelistType
    //formPropertyBackendBean.iValueMin = formPropertyBackendBean.valueMin
    //formPropertyBackendBean.iValueMax = formPropertyBackendBean.valueMax

    formPropertyBackendBean.paramInfoFormat = formPropertyBackendBean.infoFormat
    formPropertyBackendBean.paramInfoTooltip = formPropertyBackendBean.infoTooltip
    formPropertyBackendBean.paramInfoRequired = formPropertyBackendBean.infoRequired
    return formPropertyBackendBean
  }

  static formularListFlatListCompleteCopy(formularList) {
    let fieldList = []
    for (let i = 0; i < formularList.length; i++) {
      let flatList = formularList[i].formularFields.formularFlatList
      for (let j = 0; j < flatList.length; j++) {
        let newField = Object.assign({}, flatList[j])
        delete newField.setError
        delete newField.setValid
        delete newField.parentForm
        newField.validate = null
        if (newField.value !== undefined) {
          newField.defaultValue = newField.value
        }
        fieldList.push(newField)
      }
    }
    return fieldList
  }

  static formularListDeepCopy(formularList) {
    this.removeCircularDependencies(formularList)
    return JSON.parse(JSON.stringify(formularList))
  }

  static getFormularPersistFields(formularList) {
    let result = []
    formularList.forEach((form) => {
      let myFormular = {}
      myFormular.id = form.id
      myFormular.active = form.active
      myFormular.formobjectClassID = form.formobjectClassID
      myFormular.formularFields = {}
      myFormular.formularFields.formularFlatList = []
      form.formularFields.formularFlatList.forEach((field) => {
        myFormular.formularFields.formularFlatList.classID = field.classID
        myFormular.formularFields.formularFlatList.dataTypeID = field.dataTypeID
        myFormular.formularFields.formularFlatList.nativename = field.nativename
        myFormular.formularFields.formularFlatList.propertyInstanceID = field.propertyInstanceID
        myFormular.formularFields.formularFlatList.propertyInstanceValue = field.propertyInstanceValue
        myFormular.formularFields.formularFlatList.existingSubObjectIDs = field.existingSubObjectIDs
        myFormular.formularFields.formularFlatList.subInstanceID = field.subInstanceID
        myFormular.formularFields.formularFlatList.value = field.value
        if (field.subForms) {
          myFormular.formularFields.formularFlatList.subForms = this.getFormularPersistFields(field.subForms)
        }
      })
      result.push(myFormular)
    })
    return result
  }

  static removeCircularDependencies(formularList) {
    formularList.forEach((form) => {
      form.formularFields.formularFlatList.forEach((field) => {
        field.parentForm = null
        if (field.subForms) this.removeCircularDependencies(field.subForms)
      })
    })
  }

  static createBackendFormProperty(formPropertyFrontendObject, isNewInsert) {
    let formPropertyBackend = {}
    let result = null
    formPropertyBackend.propertyInstanceID = formPropertyFrontendObject.propertyInstanceID
    formPropertyBackend.value = formPropertyFrontendObject.value
    formPropertyBackend.propertyInstanceValue = formPropertyFrontendObject.propertyInstanceValue
    formPropertyBackend.defaultValue = formPropertyFrontendObject.defaultValue
    formPropertyBackend.nativename = formPropertyFrontendObject.nativename
    formPropertyBackend.dataTypeID = formPropertyFrontendObject.dataTypeID
    formPropertyBackend.classID = formPropertyFrontendObject.classID
    formPropertyBackend.blobAsBytes = formPropertyFrontendObject.blobAsBytes
    formPropertyBackend.blobAsString = formPropertyFrontendObject.blobAsString
    formPropertyBackend.ticketRangeID = formPropertyFrontendObject.ticketRangeID
    formPropertyBackend.readonly = formPropertyFrontendObject.readonly
    formPropertyBackend.externalstorage = formPropertyFrontendObject.externalstorage

    if(formPropertyFrontendObject.pdfCompressionLevel !== 0){
      formPropertyBackend.pdfCompressionLevel = formPropertyFrontendObject.pdfCompressionLevel
    }

    if(formPropertyBackend.zipCompressionLevel!==0){
      formPropertyBackend.zipCompressionLevel = formPropertyFrontendObject.zipCompressionLevel
    }

    if (formPropertyFrontendObject.existingSubObjectIDs) {
      formPropertyBackend.existingSubObjectIDs = []
      if (formPropertyFrontendObject.existingSubObjectIDs.length > 0) {
        formPropertyBackend.existingSubObjectIDs = [...formPropertyFrontendObject.existingSubObjectIDs]
      }
    }
    formPropertyBackend.subInstanceID = formPropertyFrontendObject.subInstanceID
    let countChangeSubFields = 0
    if (formPropertyFrontendObject.subForms) {
      formPropertyBackend.subForms = []
      if (formPropertyFrontendObject.subForms.length > 0) {
        formPropertyBackend.subForms = this.formularListDeepCopy(formPropertyFrontendObject.subForms)
        formPropertyBackend.subForms.forEach((form) => {
          if (form.formularFields.formularFlatList) {
            let tmpList = []
            form.formularFields.formularFlatList.forEach((subField) => {
              // if (isNewInsert || (subField.value && ((subField.defaultValue !== subField.value) || subField.nativename === 'oiID'))) { // datatype 16 - only read textfield must not be persisted
              let tmpField = this.createBackendFormProperty(subField)
              tmpList.push(tmpField)
              countChangeSubFields++
              // }
            })
            form.formularFields.formularFlatList = tmpList
          }
        })
      }
    }

    // if (!formPropertyFrontendObject.subForms || countChangeSubFields > 0) {
    result = formPropertyBackend
    // }
    return result
  }
}
